import React, { useEffect, useState } from 'react'
import BackButton from '../components/BackButton'
import { Swiper, SwiperSlide } from 'swiper/react';
import { handleRedirect, UploadTalkingPhoto } from '../Script'
import { getCachedData, UpdateExpiredTalkingPhoto } from '../Firebase'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { uploadPhotoFirebase, getUploads, UpdateUserLimits } from '../Firebase'
import camera from '../assets/icons8-camera-50.png'
import 'swiper/css';

export default function TalkingPhoto() {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [talkingphoto, setTalkingPhotos] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isUploadLoading, setIsUploadLoading] = useState(false);
    const [isGetUploadLoading, setIsGetUploadLoading] = useState(true);
    const [isRefreshingExpired, setIsRefreshingExpired] = useState(false);
    const [uploads, setUploads] = useState(false);
    const [userData, setUserData] = useState()

    const [alertMessage, setAlertMessage] = useState("")
    const [alertType, setAlertType] = useState("")
    const [isAlertOpen, setIsAlertOpen] = useState("")

    const [selectedImage, setSelectedImage] = useState(null);
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const showModal = () => setIsModalOpen(true);
    const handleOk = () => setIsModalOpen(false);

    const closeAlert = () => setIsAlertOpen("");

    const fetchData = async () => {
        try {
            setIsGetUploadLoading(true)
            setIsLoading(true);

            // Fetch user uploads
            try {
                console.log("📍 [TalkingPhoto] Fetching user uploads...");
                const images = await getUploads();
                console.log("✅ [TalkingPhoto] User uploads received:", images ? `${Array.isArray(images) ? images.length : 0} uploads` : "No uploads");
                setUploads(images || []);
            } catch (uploadError) {
                console.error("❌ [TalkingPhoto] Error fetching user uploads:", uploadError);
                setAlertMessage("Failed to load your uploaded photos. Please try again.");
                setAlertType("danger");
                setIsAlertOpen("show");
                setUploads([]); // Set empty to avoid errors
            } finally {
                setIsGetUploadLoading(false);
            }

            // Fetch cached talking photos
            try {
                console.log("📍 [TalkingPhoto] Fetching talking photos...");
                const photos = await getCachedData("talking_photos");
                console.log("✅ [TalkingPhoto] Photos received:", photos ? `${photos.length} photos` : "No photos");
                console.log("📸 [TalkingPhoto] Photos source tracked in getCachedData()");
                
                // Set initial photos (may be empty)
                setTalkingPhotos(photos || []);
                
                // Check and refresh expired photos (this may fetch from HeyGen API)
                setIsRefreshingExpired(true);
                try {
                    await UpdateExpiredTalkingPhoto();
                    
                    // Re-fetch photos in case they were updated from HeyGen
                    const updatedPhotos = await getCachedData("talking_photos");
                    if (updatedPhotos) {
                        setTalkingPhotos(updatedPhotos);
                    }
                } catch (refreshError) {
                    console.error("❌ [TalkingPhoto] Error refreshing expired photos:", refreshError);
                    // Don't show error to user, keep existing photos
                } finally {
                    setIsRefreshingExpired(false);
                }
            } catch (cacheError) {
                console.error("❌ [TalkingPhoto] Error fetching talking photos:", cacheError);
                setAlertMessage("Failed to load available talking photos. Please try again.");
                setAlertType("danger");
                setIsAlertOpen("show");
                setTalkingPhotos([]); // Set empty to avoid errors
            } finally {
                setIsLoading(false);
            }

        } catch (error) {
            console.error("Unexpected error fetching data:", error);
            setAlertMessage("Something went wrong while retrieving data.");
            setAlertType("danger");
            setIsAlertOpen("show");
            setIsLoading(false);
            setIsGetUploadLoading(false);
            setIsRefreshingExpired(false);
        }
    };

    useEffect(() => {
        const session = JSON.parse(sessionStorage.getItem("AI_UserData"))
        setUserData(session)
        fetchData();
    }, []); // Runs only on mount

    const handleFileChange = async (event) => {

        if (userData.upload_limit === 0) {
            handleOk()
            setAlertMessage("You have reached your upload limit!")
            setAlertType("danger")
            setIsAlertOpen("show")
        } else {
            setIsUploadLoading(true);
            const file = event.target.files[0];

            if (file) {
                try {
                    const UploadResponse = await UploadTalkingPhoto(file);
                    console.log("IMAGE upload response : ", UploadResponse.code);
                    console.log("upload response : ", UploadResponse);

                    if (UploadResponse.code != 100) {
                        setAlertMessage(UploadResponse.message)
                        setAlertType("success")
                        setIsAlertOpen("show")
                    } else {
                        uploadPhotoFirebase(UploadResponse.data);
                        UpdateUserLimits("upload_limit", userData.phone)

                        let existingUploads = sessionStorage.getItem("AI_Uploads");
                        existingUploads = existingUploads ? JSON.parse(existingUploads) : [];
                        existingUploads.unshift({
                            id: UploadResponse.data.talking_photo_id,
                            image_url: UploadResponse.data.talking_photo_url
                        });
                        sessionStorage.setItem("AI_Uploads", JSON.stringify(existingUploads));
                        setUploads(existingUploads);
                    }

                } catch (uploadError) {
                    console.error("Error uploading photo:", uploadError);
                    setAlertMessage("Failed to upload photo. Please try again.");
                    setAlertType("danger");
                    setIsAlertOpen("show");
                } finally {
                    setIsUploadLoading(false);
                    handleOk();
                }
            }
        }
    };

    return (
        <>
            <div className='pt-4' style={{ marginBottom: "12rem" }}>

                <div className='container' data-aos='fade-down'>
                    <BackButton title="Talking Photos" />
                    {isAlertOpen &&
                        <div className={`alert alert-${alertType} alert-dismissible fade show`} data-aos='fade-right' role="alert">
                            <h3>{alertMessage}</h3>
                            <button type="button" className="btn-close" aria-label="Close" onClick={closeAlert}></button>
                        </div>
                    }
                </div>

                <Swiper
                    className={width > 720 ? 'container' : 'ma-container'} data-aos="fade-down"
                    spaceBetween={0}
                    slidesPerView={3}>

                    <SwiperSlide className='card-small' onClick={showModal}>
                        <img style={{ width: '35px' }} src={camera} />
                        <h2 className='mt-1'>Add Photo</h2>
                    </SwiperSlide>

                    {isGetUploadLoading ? (
                        <>
                            {Array(3).fill(0).map((_, index) => (
                                <SwiperSlide key={`skeleton-${index}`} className='card-small card-small-skeleton'>
                                    <div style={{ width: '35px', height: '35px', borderRadius: '50%', backgroundColor: '#e0e0e0', margin: '0 auto' }}></div>
                                </SwiperSlide>
                            ))}
                        </>
                    ) : (
                        uploads && uploads.length > 0 ?
                            uploads.map((item, index) => (
                                <SwiperSlide className="card-small" key={index} onClick={() => handleRedirect(item, 'talking_photo')}>
                                    <img className='slider_image' src={item.image_url} alt={`Upload ${index}`} />
                                </SwiperSlide>
                            ))
                            : ""
                    )}

                </Swiper>

                <div className='container mt-6'>
                    <h1 className='mb-2'>Available Talking Photos</h1>
                    <div className='photo-grid' data-aos='fade-up'>
                        {(isLoading || isRefreshingExpired) ? (
                            Array(6).fill(0).map((_, index) => (
                                <div key={index} className='skeleton-square'></div>
                            ))
                        ) : talkingphoto && talkingphoto.length > 0 ? (
                            talkingphoto.map((photo, index) => (
                                <LazyLoadImage
                                    key={index}
                                    onClick={() => handleRedirect(photo, 'talking_photo')}
                                    src={photo.image_url}
                                    alt={`Photo ${index}`}
                                    loading='lazy'
                                />
                            ))
                        ) : !isLoading && !isRefreshingExpired ? (
                            <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '2rem', color: '#666' }}>
                                <h3>No talking photos available</h3>
                            </div>
                        ) : ""}
                    </div>
                </div>
            </div>

            {isModalOpen &&
                <div className='modal-div'>
                    <div className='bottom-modal'>
                        <h2
                            className='pr-4 py-2'
                            style={{ textAlign: 'right', cursor: 'pointer' }}
                            onClick={handleOk}
                        >
                            ✖
                        </h2>
                        <div className='container d-flex flex-column gap-4 pb-4'>
                            {/* Open Camera */}
                            <label
                                htmlFor="cameraInput"
                                className="button-modal bold"
                                style={{ background: '#8080802b', cursor: 'pointer' }}
                            >
                                <h2>Take Photo</h2>
                            </label>
                            <input
                                id="cameraInput"
                                type="file"
                                accept="image/*"
                                capture="environment"
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />

                            {/* Upload from Gallery */}
                            <label
                                htmlFor="galleryInput"
                                className="button-modal bold"
                                style={{
                                    background: 'black',
                                    color: isUploadLoading ? '#aaa' : 'white',
                                    cursor: isUploadLoading ? 'not-allowed' : 'pointer',
                                    pointerEvents: isUploadLoading ? 'none' : 'auto',
                                    opacity: isUploadLoading ? 0.7 : 1,
                                }}
                            >
                                {isUploadLoading ? <h2>Uploading ...</h2> : <h2>Upload From Gallery</h2>}
                            </label>

                            <input
                                id="galleryInput"
                                type="file"
                                accept="image/*"
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
